import { api } from "./axiosConfig";

export const GET_CATEGORY_IMAGE_MAP_SERVICE = async () => {
  return await api.get(process.env.REACT_APP_GET_CATEGORY_IMAGE_MAP_URL);
};
